<template>
  <window-container class="product-advance-window" @window-return="windowReturn">
    <div class="title">
      <div style="float:left;">Edit Item {{ $route.params.id }}</div>
      <div style="float:right;">
        <!-- <el-button @click="del">Delete</el-button>
        <el-button @click="merge">Merge Item</el-button> -->
      </div>
      <div style="clear:both;"></div>
    </div>
    <el-form ref="form" :model="form" label-width="160px" class="form">
      <el-form-item label="Category">
        <el-select v-model="form.category_id">
          <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button type="text" @click="$open('/category-edit/' + form.category_id, 600, 600)">Edit Category</el-button>
      </el-form-item>
      <el-form-item label="Class">
        <el-select v-model="form.class_id">
          <el-option v-for="item in classListFilter" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button type="text" @click="$open('/class-edit/' + form.class_id, 600, 600)">Edit Class</el-button>
      </el-form-item>
      <el-form-item label="Part Number" required>
        <el-input v-model="form.part_no"></el-input>
      </el-form-item>
      <el-form-item label="Description" prop="description" required>
        <el-input v-model="form.description"></el-input>
      </el-form-item>
      <el-form-item label="Brand" required>
        <el-input v-model="form.brand"></el-input>
      </el-form-item>
      <el-form-item label="Packing">
        <el-input type="textarea" v-model="form.packing"></el-input>
      </el-form-item>
      <el-form-item label="Information">
        <el-input type="textarea" :rows="3" v-model="form.information"></el-input>
      </el-form-item>
      <el-form-item label="Remark">
        <el-input type="textarea" :rows="3" v-model="form.remark"></el-input>
      </el-form-item>
      <el-form-item label="Replace Part Number">
        <table>
          <tr v-for="item in replaces" :key="item.id">
            <td>{{ item.part_no }}</td>
            <td><el-button icon="el-icon-close" @click="delReplace(item.id)"></el-button></td>
          </tr>
          <tr>
            <td style="width:300px;">
              <el-select v-model="replaceProductId" filterable remote :remote-method="searchProduct" style="width:100%;">
                <el-option v-for="item in productList" :key="item.id" :label="item.part_no" :value="item.id"></el-option>
              </el-select>
            </td>
            <td>
              <el-button icon="el-icon-check" @click="addReplace(product.id)"></el-button>
            </td>
          </tr>
        </table>
      </el-form-item>
      <!--
      <el-form-item label="Visibility">
        <el-checkbox true-label="1" false-label="0" v-model="form.v_offer">Offer</el-checkbox>
        <el-checkbox true-label="1" false-label="0" v-model="form.v_require">Requirement</el-checkbox>
        <el-checkbox true-label="1" false-label="0" v-model="form.v_stock">Stock</el-checkbox>
        <el-checkbox true-label="1" false-label="0" v-model="form.v_po">Po</el-checkbox>
        <el-checkbox true-label="1" false-label="0" v-model="form.v_invoice">Invoice</el-checkbox>
      </el-form-item>
      -->
    </el-form>
    <div class="buttons">
      <el-button type="primary" @click="update">Update Item</el-button>
      <el-button @click="insert">Save As New</el-button>
      <el-button @click="reset">Reset</el-button>
      <el-button @click="$close()">Exit</el-button>
      <el-button type="danger" @click="del">Delete</el-button>
    </div>
    <div class="footer">
      <div>Create by: {{ product.create_oper_name }} at {{ product.create_time }}</div>
      <div v-if="product.update_oper_name">Update by: {{ product.update_oper_name }} at {{ product.update_time }}</div>
    </div>
  </window-container>
</template>

<script>
export default {
  data () {
    return {
      product: {},
      form: {
        id: 0,
        category_id: 0,
        class_id: 0,
        description: '',
        part_no: '',
        brand: '',
        remark: '',
        packing: '',
        information: ''
        //marketing: '',
        //technical: '',
        //v_offer: '1',
        //v_require: '1',
        //v_stock: '1',
        //v_po: '1',
        //v_invoice: '1'
      },
      replaces: [],
      replaceProductId: null,
      productList: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    categoryList () {
      return this.$store.state.select.category
    },
    classList () {
      return this.$store.state.select.class
    },
    classListFilter () {
      if (this.form.category_id === 0) {
        return this.classList
      }
      return this.classList.filter(r => r.category_id === this.form.category_id)
    }
  },
  mounted () {
    this.fetchProduct()
    this.fetchReplaces()
    this.$store.dispatch('fetchSelect', 'category')
    this.$store.dispatch('fetchSelect', 'class')
  },
  methods: {
    windowReturn () {
      this.$store.dispatch('fetchSelect', 'category')
      this.$store.dispatch('fetchSelect', 'class')
    },
    fetchProduct () {
      this.$http.get('/dbapi/product_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.product = data.list[0]
          this.reset()
        }
      })
    },
    fetchReplaces () {
      this.$http.get('/dbapi/product_replace?product_id=' + this.$route.params.id).then(data => {
        this.replaces = data.list
      })
    },
    reset () {
      this.form.id = this.product.id
      this.form.category_id = this.product.category_id
      this.form.class_id = this.product.class_id
      this.form.description = this.product.description
      this.form.part_no = this.product.part_no
      this.form.brand = this.product.brand
      this.form.packing = this.product.packing
      this.form.information = this.product.information
      this.form.remark = this.product.product_remark
      //this.form.marketing = this.product.marketing
      //this.form.technical = this.product.technical
      //this.form.v_offer = this.product.v_offer
      //this.form.v_require = this.product.v_require
      //this.form.v_stock = this.product.v_stock
      //this.form.v_po = this.product.v_po
      //this.form.v_invoice = this.product.v_invoice
    },
    insert () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$http.get('/dbapi/check_product?part_no=' + this.form.part_no).then(data => {
            if (data.list.length > 0) {
              this.$alert('Part Number重复', '提示')
            } else {
              this.$http.post('/dbapi/product_insert', this.form).then(data => {
                this.$message({
                  type: 'success',
                  message: 'Saved.'
                })
                window.opener.location.href = window.opener.location.href.replace(this.$route.params.id, data.insertId)
                this.$close()
              })
            }
          })
        }
      })
    },
    update () {
      let confirmMsg = '确定修改吗?'
      if (this.form.part_no != this.product.part_no) {
        if (this.user.role_id > 2) {
          this.$alert('您没有权限修改Part Number', '提示')
          return
        }
        confirmMsg = '确定要修改Part Number吗?'
      }
      this.$confirm(confirmMsg, '提示', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.$http.post('/dbapi/product_update', this.form).then(data => {
              this.$message({
                type: 'success',
                message: 'Saved.'
              })
              this.$close()
            })
          }
        })
      })
    },
    del () {
      this.$confirm('Delete?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/product_delete', this.form).then(data => {
          this.$message({
            type: 'success',
            message: 'Saved.'
          })
          this.$close()
        })
      })
    },
    merge () {
      this.$message({
        type: 'error',
        message: 'You do not have permission to do this'
      })
    },
    searchProduct (query) {
      this.$http.get('/dbapi/product_list?part_no=' + query).then(data => {
        this.productList = data.list
      })
    },
    addReplace (product_id) {
      if (!this.replaceProductId) {
        return
      }
      this.$http.post('/dbapi/product_replace_insert', {
        product_id: product_id,
        r_product_id: this.replaceProductId
      }).then(data => {
        this.fetchReplaces()
        this.replaceProductId = null
      })
    },
    delReplace (id) {
      this.$http.post('/dbapi/product_replace_delete', {
        id
      }).then(data => {
        this.fetchReplaces()
      })
    }
  }
}
</script>

<style>
.product-advance-window {
  background-color: #fff;
}
.product-advance-window .title {
  background-color: #b0c8f5;
  font-size: 16px;
  font-weight: bold;
  padding: 4px 10px;
}
.product-advance-window .form .el-form-item {
  margin-bottom: 0;
  border-bottom: 1px solid #ddd;
}
.product-advance-window .form .el-form-item__content {
  border-left: 1px solid #ddd;
  padding: 2px;
}
.product-advance-window .buttons {
  padding: 4px;
  border-bottom: 1px solid #ddd;
}
.product-advance-window .footer {
  padding: 4px;
  border-bottom: 1px solid #ddd;
}
</style>